import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
// For development purposes, we're using placeholder values
// In a production environment, these would be environment variables
const firebaseConfig = {
  apiKey: "AIzaSyC5L4qhF2ovQnCEs0zfx8eijg80AbTs1T4",
  authDomain: "lightway-app.firebaseapp.com",
  projectId: "lightway-app",
  storageBucket: "lightway-app.firebasestorage.app",
  messagingSenderId: "863991835439",
  appId: "1:863991835439:web:fb34109d0d4afd3f368fda"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();

export default app;
